<template>
<div class="fixed-navbar">
      <div class="app-content content container-fluid" ><!--style="padding-top: 4rem"-->
        <div class="content-wrapper">
          <router-view />
        </div>
      </div>
</div> 
</template>

<script>
import Footer from '../components/Footer';

    export default {
        name: "content-container",
        components: {
          Footer,
        },
        data() {
            return {}
        },
        mounted() {
        },
        created() {
        },
        methods: {
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Content.vue